import React from 'react';

/**
 * @props
 *  .id {String}
 *  .value {String} optional
 *  .placeholder {String}
 *  .changeFormFieldListener {function} 
 * @returns 
 */
const InputTextItem = ({
    id,
    value,
    changeFormFieldListener,
    placeholder
}) => {

    const ref = React.useRef(null);

    // When a new value is received as a prop, calls update
    React.useEffect(() => {
        if (value) {
            update(value);
        }
    }, [value]);

    /**
     * Input HTMLElement onChange listener
     * When the input's vlaue changes, calls dispatch
     * @param {Event} evt 
     */
    const onChange = evt => {
        dispatch();
    };

    /**
     * Both updates the gui with value and calls dispatch
     * @param {String} value 
     */
    const update = value => {
        updateGuiValue(value);
        dispatch();
    };

    /**
     * Calls the changeFormFieldListener received as a prop
     */
    const dispatch = () => {
        changeFormFieldListener({
            target: ref.current
        });
    };

    /**
     * Updates input HTMLElement with value
     * @param {String} value 
     */
    const updateGuiValue = value => {
        ref.current.value = value;
    };

    return (
        <div className="slc-form-input-text-widget" id={ id }>
            <div className="slc-form-input-text-widget__input-container">
                <input
                    ref={ ref }
                    type="text"
                    className={`slc-form-input-text-widget__input slc-form-input-text-widget__input-${ id }`}
                    onChange={ onChange }
                    placeholder={ placeholder } />
            </div>
        </div>
    );

};

export default InputTextItem;